"use client";

import { EdgenModalCreateAble } from "@components/EdgenModal";
import {
  CrossChannelGuideModalContent,
  type CrossChannelGuideResult,
} from "./CrossChannelGuideModalContent";

/** 以 EdgenModalCreateAble 打开跨渠道引导（与升级确认同款居中弹窗）；关闭时 resolve 用户的选择。 */
export const openCrossChannelGuideModal =
  (): Promise<CrossChannelGuideResult> =>
    new Promise<CrossChannelGuideResult>((resolve) => {
      const modal = EdgenModalCreateAble.call({
        destroyOnClose: true,
        className: "text-content_primary md:w-[480px] max-w-full rounded-2xl",
        showClose: false,
        maskClosable: false,
        contentStyle: { padding: 0 },
        children: (
          <CrossChannelGuideModalContent
            onDone={(result) => {
              EdgenModalCreateAble.end(modal, false);
              resolve(result);
            }}
          />
        ),
      });
    });
